import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        outline: 0;
        box-sizing: border-box;
    }

    :root {
        --white: #f9f9f9;
        --black: #0c0d0d;
        --light-vellow: #bdb491;
        --dark-goldenrod: #bd9700;
        --red: #830000;
        --black-russian: #03031b;
        --log-cabin: #3c4135;
        --winter-hazel: #d2c57c;
        --mint-cream: #f5fffa;
        --ghost-white: #f8f8ff;
        --gainsboro: #dcdcdc;
    }

    body {
        background-color: var(--ghost-white);
    }

    #root {
        display: flex;
        justify-content: center;
        flex-flow: column wrap;
        align-items: center;
    }

    h1, h2, h3, h4, h5, h6 {
        font-weight: 600;
    }
    
    body, input, button {
        font-family: 'Lato', sans-serif;
        font-size: 1rem;
        color: var(--black-russian);
    }

    button {
        cursor: pointer;
    }

    a {
        text-decoration: none;
    }

    li {
        list-style: none;
    }
`;
